module.exports = __webpack_public_path__ + "img/comodo-secure.483bfc28.png";